import { Map as ImmutableMap } from 'immutable';
import { generateDrilldownReport } from 'reporting-data/config/drilldown/generate';
import { isSupported, isSupportedColumn } from 'reporting-data/config/drilldown/isSupported';
import { DATA_WELL, TABLE } from 'reporting-data/constants/chartTypes';
// @ts-expect-error Untyped dependency
import { load } from 'reporting-data/dataTypeDefinitions';
import { Promise } from 'reporting-data/lib/promise';
import { isBaseReport, isConfigReport, isCustomWidgetReport, isMultiConfigReport, isReportWithPlugins } from 'reporting-data/tsTypes/reportTypes';
// @ts-expect-error Untyped dependency
import { isOnlySupportedViaBackendResolve } from 'reporting-data/v2/reportingApi/isSupportedForBackendResolve';
const onDrilldownPath = ['displayParams', 'onDrilldown'];
const createMetricDrilldowns = (report, options, dataTypeModule) => {
  const onDrilldownFunc = report.getIn(onDrilldownPath);
  if ([TABLE, DATA_WELL].includes(report.get('chartType'))) {
    const clickHandler = (keys, additionalOptions) => generateDrilldownReport(report, keys, Object.assign({}, options, additionalOptions)).then(onDrilldownFunc);
    const columns = report.getIn(['config', 'metrics']).map(metric => metric.get('property')).filter(column => isSupportedColumn(report, column, dataTypeModule)).reduce((acc, col) => acc.set(col, ImmutableMap({
      onDrilldown: clickHandler
    })), ImmutableMap());
    return report.updateIn(['displayParams', 'columns'], ImmutableMap(), oldColumns => oldColumns.mergeDeep(columns));
  }
  return report;
};
export function getBaseReportForDrilldown(report, options) {
  if (isMultiConfigReport(report) && options.datasetKey) {
    const innerConfig = report.getIn(['reportConfigs', options.datasetKey]);
    if (innerConfig) {
      return ImmutableMap({
        config: innerConfig
      });
    } else {
      return report.remove('visualization').remove('reportConfigs');
    }
  }
  return report;
}
export function drilldownDecorator(report, options = {}) {
  const isCustomWidget = isCustomWidgetReport(report) && report.getIn(['displayParams', 'customWidget', 'type'], 'DATA_LAYER') !== 'DATA_LAYER';
  const onDrilldownFunc = isBaseReport(report) && report.getIn(onDrilldownPath);
  if (!onDrilldownFunc || isCustomWidget) {
    return Promise.resolve(report);
  }
  const dataType = report.getIn(['config', 'dataType']);
  return load(dataType).then(dataTypeModule => {
    const onlySupportedViaBackendResolve = isOnlySupportedViaBackendResolve(report);
    if (!dataTypeModule && !onlySupportedViaBackendResolve || !isConfigReport(report) && !isReportWithPlugins(report)) {
      return report;
    }
    return isSupported(report, dataTypeModule).then(supported => {
      if (!supported) {
        return report;
      }
      const displayParam = [TABLE, DATA_WELL].includes(report.get('chartType')) ? 'onClick' : 'onChartClick';
      return report.setIn(['displayParams', displayParam], (keys, additionalOptions) => {
        const reportForDrilldown = getBaseReportForDrilldown(report, additionalOptions);
        return generateDrilldownReport(reportForDrilldown, keys, Object.assign({}, options, additionalOptions)).then(onDrilldownFunc);
      });
    }).then(rep => createMetricDrilldowns(rep, options, dataTypeModule)).then(rep => rep.deleteIn(['displayParams', 'onDrilldown']));
  });
}
export const __TESTABLE__ = {
  getBaseReportForDrilldown
};